import { Box, FormControl } from "@primer/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import TextInput from "../../components/ui/text-input";

import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

import { IMeetingBusy } from "../../models/response/meeting/IMeetingBusy";
import { meetingBusyApi } from "../../api/meetingBusyApi";
import { useAuth } from "../../hooks/useAuth";

interface Props {
    isOpen: boolean;
    id: number;
    onClose: () => void;
    onSuccess?: () => void;
}

const MeetingBusyDetailModal = ({
    isOpen,
    id,
    onClose,
    onSuccess
}: Props) => {
    const { nam_hoc } = useCommonSelectedHook();
    const { user_info } = useAuth();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<IMeetingBusy>({
        mode: "all"
    });

    const [item, setItem] = useState<IMeetingBusy>({} as IMeetingBusy);

    useEffect(() => {
        if (id > 0) {
            handleGetDataAsync();
        }
        else {
            reset({
                start_time: undefined,
                end_time: undefined
            });
        }
    }, [id]);

    const handleGetDataAsync = async () => {
        const res = await meetingBusyApi.detail(id);

        if (res.is_success) {
            setItem(res.data);

            reset({
                ...res.data,
                start_time: res.data.start_time
                    ? moment(res.data.start_time).format("YYYY-MM-DDTHH:mm")
                    : undefined,
                end_time: res.data.end_time
                    ? moment(res.data.end_time).format("YYYY-MM-DDTHH:mm")
                    : undefined
            });
        }
    };

    const onSubmit = async (data: any) => {
        const payload = {
            ...item,
            ...data,
            nam_hoc,
            sis_giaovien_id: user_info?.sis_giaovien_id,
            start_time: moment(data.start_time).format("YYYY-MM-DDTHH:mm:ss"),
            end_time: moment(data.end_time).format("YYYY-MM-DDTHH:mm:ss")
        };

        const res =
            id > 0
                ? await meetingBusyApi.update(payload)
                : await meetingBusyApi.insert(payload);

        if (res.is_success) {
            NotifyHelper.Success("Success");
            onSuccess?.();
            onClose();
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }
    };

    return (
        <Modal
            width="large"
            isOpen={isOpen}
            title="Lịch bận giáo viên"
            onClose={onClose}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box
                    sx={{
                        display: "grid",
                        gap: 3
                    }}
                >
                    <FormControl>
                        <FormControl.Label>
                            Nội dung
                        </FormControl.Label>

                        <TextInput
                            name="ghi_chu"
                            register={register}
                            required
                            errors={errors}
                            validateMessage="Vui lòng nhập nội dung bận"
                            width={'100%'}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>
                            Từ thời gian
                        </FormControl.Label>

                        <TextInput
                            type="datetime-local"
                            name="start_time"
                            register={register}
                            required
                            errors={errors}
                            validateMessage="Vui lòng chọn thời gian bắt đầu"
                        />
                    </FormControl>

                    <FormControl>
                        <FormControl.Label>
                            Đến thời gian
                        </FormControl.Label>

                        <TextInput
                            type="datetime-local"
                            name="end_time"
                            register={register}
                            required
                            errors={errors}
                            validateMessage="Vui lòng chọn thời gian kết thúc"
                        />
                    </FormControl>
                </Box>

                <ModalActions>
                    <Button
                        text="Đóng"
                        onClick={onClose}
                    />

                    <Button
                        text={id > 0 ? "Cập nhật" : "Thêm mới"}
                        type="submit"
                        variant="primary"
                    />
                </ModalActions>
            </form>
        </Modal>
    );
};

export default MeetingBusyDetailModal;
